import {Pipe, PipeTransform } from '@angular/core';

@Pipe({name:'nofeshStatus'})

export class NofeshStatusPipe implements PipeTransform{
    transform(value: number): string {
        let response: string;
        if (value == 0)
            response = 'פנוי';
        if (value == 1)
            response = 'המתנה';
        if (value == 2)
            response = 'מלא';

        return response;
    }
} 